module.exports = __WEBPACK_EXTERNAL_MODULE_152__;


//////////////////
// WEBPACK FOOTER
// external "my-ip"
// module id = 152
// module chunks = 0